module.exports = __webpack_public_path__ + "img/home_four_006.6bb87c55.png";